import { StyleProps, SystemProps } from '@chakra-ui/styled-system';

export const menuButtonStyleProps: SystemProps = {
  display: 'inline-block',
  top: '50%',
  position: 'absolute',
  right: '0',
  cursor: 'pointer',
  borderRadius: '50%',
  border: '1px solid rgb(204, 204, 204, 0)',
  transition: 'border 100ms ease',
  transform: 'translateY(-50%)',
  _hover: {
    borderColor: 'gray.200',
  },
  _focus: {
    outline: 'none',
    borderColor: 'gray.200',
  },
  _active: {
    outline: 'none',
  },
};

export const simpleMButtonStyleProps: SystemProps = {
  position: 'relative',
  cursor: 'pointer',
  _hover: {
    borderColor: 'gray.200',
  },
  _focus: {
    outline: 'none',
    borderColor: 'gray.200',
  },
  _active: {
    outline: 'none',
  },
};

export const iconStyleProps: StyleProps = {
  top: '50%',
  left: '50%',
  position: 'absolute',
  transform: 'translate(-50%, -50%)',
  transition: 'color 100ms ease',
};

export const menuItemStyleProps: SystemProps = {
  h: '47px',
  _hover: {
    color: 'black',
    backgroundColor: 'gray.50',
    textDecoration: 'none',
  },
};
